import React, { useEffect, useMemo, useState, useCallback } from "react";
import FormDetail from "../../../../../src/components/Form/FormDetail";
import { updateTaskSla } from "../../../../request/task";
import { Paper } from "@mui/material";

export default function SlaForm({ data, onSave = () => {} }) {
  const [item, setItem] = useState(data);

  useEffect(() => {
    setItem(data);
  }, [data]);

  // for card form
  const [saveResult, setSaveResult] = useState({});
  const afterSave = (response) => {
    if (!response.data) {
      const message = JSON.parse(response);
      setSaveResult({ error: message?.errorText });
      return;
    }
    onSave();
    setSaveResult({ success: true });
  };

  const onSubmit = useCallback(
    async (values) => {
      let fields = { ...values };

      let response = await updateTaskSla(item.id, fields);
      afterSave(response);
    },
    [item],
  );

  const getFields = useMemo(() => {
    if (!item) return [];
    let fields = [
      {
        id: "first_comment_seconds",
        title: "First Comment SLA",
        type: "duration",
        value: parseInt(item?.sla?.first_comment_seconds),
      },
      {
        id: "in_progress_seconds",
        title: "In Proccess SLA",
        type: "duration",
        value: parseInt(item?.sla?.in_progress_seconds),
      },
      {
        id: "lifetime_seconds",
        title: "Lifetime SLA",
        type: "duration",
        value: parseInt(item?.sla?.lifetime_seconds),
      },
    ];

    return fields;
  }, [item]);

  return (
    <>
      {item && (
        <div className="sla-detail">
          <Paper sx={{ padding: "15px" }}>
            <h2>{item.name}</h2>
            <FormDetail
              fields={getFields}
              onSubmitHandler={onSubmit}
              submitResult={saveResult}
            />
          </Paper>
        </div>
      )}
    </>
  );
}
